import React, { useState } from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { NavLink } from "react-router-dom";
import FavoriteIcon from "@mui/icons-material/Favorite";
import "./sidenav/sidenav.css";
import { useAuth } from "../auth/authContext";

const SideNav = () => {
  const { SideNav, navData } = useAuth();
  const [open, setOpen] = useState(true);
  const [openChild, setOpenChild] = useState(false);
  const role = localStorage.getItem("role");

  const toggleOpen = () => {
    setOpen(!open);
    SideNav(!open);
  };

  const toggleChildOpen = () => {
    setOpenChild(!openChild);
  };

  return (
    <div className={open ? "sidenav" : "sidenavClosed"}>
      <div className="text-right">
        <button className="menuBtn" onClick={toggleOpen}>
          {open ? <ArrowCircleLeftIcon /> : <ArrowCircleRightIcon />}
        </button>
      </div>

      {/* Render Navigation Items */}
      {navData.map((item) => (
        <div key={item.id}>
          <NavLink
            className={({ isActive }) => `sideitem ${isActive ? "active" : ""}`}
            to={item.link}
            onClick={
              item.children && item.id === 15 ? toggleChildOpen : undefined
            } // Handle toggle for child items
          >
            <div className="sideItemchild">
              <div>
                {item.icon}
                <span className={open ? "linkText" : "linkTextClosed"}>
                  {item.text}
                </span>
              </div>
              {item.children && (
                <div>
                  {openChild ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </div>
              )}
            </div>
          </NavLink>

          {/* Child Menu Items */}
          {item.children && item.children.length > 0 && (
            <div className={openChild ? "childMenuOpen" : "childMenu"}>
              {item.children.map((child) => {
                // Add role check for child items if necessary
                if (child.role === role) {
                  return (
                    <NavLink
                      key={child.id}
                      className="childMenuSideNav"
                      to={child.link}
                    >
                      {child.icon}
                      <span className={open ? "linkText" : "linkTextClosed"}>
                        {child.text}
                      </span>
                    </NavLink>
                  );
                }
                return null;
              })}
            </div>
          )}
        </div>
      ))}

      <p className={open ? "foot_head fs-12 me-2 fw-600" : "linkTextClosed"}>
        Powered by RevaaloLabs{" "}
        <span>
          <FavoriteIcon className="ms-2 text-danger" />
        </span>
      </p>
    </div>
  );
};

export default SideNav;
